export default __webpack_public_path__ + "static/resource-bg-1-545bea1b4351fa07d062334513e89d6b.png";